{
  "name": "41-Septimal-Tertial (Tonnetz Layout)",
  "description": "41-tone 7-Limit Rational Intonation scale by Marc Sabat, inspired by La Monte Young’s Well-Tuned-Piano 12-note tuning. The Pythagorean diatonic tones (C-D, D-E, F-G, G-A, A-B) are each divided Limma-Comma-Limma (i.e., C, D♭, C♯, D), producing a division of the octave into 5 Pythagorean Commas and 12 limmas (including E-F and B-C). Each Limma is divided further into three septimal intervals with sizes 63:64, 48:49, 63:64. The resulting 41 note scale consists of 5 Pythagorean Commas (24c), 12 48:49’s (35c), and 24 Septimal Commas (27c).",
  "scale": [
    "64/63",
    "28/27",
    "256/243",
    "2187/2048",
    "243/224",
    "567/512",
    "9/8",
    "8/7",
    "7/6",
    "32/27",
    "19683/16384",
    "2187/1792",
    "5103/4096",
    "81/64",
    "9/7",
    "21/16",
    "4/3",
    "256/189",
    "112/81",
    "1024/729",
    "729/512",
    "81/56",
    "189/128",
    "3/2",
    "32/21",
    "14/9",
    "128/81",
    "6561/4096",
    "729/448",
    "1701/1024",
    "27/16",
    "12/7",
    "7/4",
    "16/9",
    "59049/32768",
    "6561/3584",
    "15309/8192",
    "243/128",
    "27/14",
    "63/32",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "41-JI-7L(MS-LMY)",
  "built_in_group": "Rational Intonation (JI)",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "C",
    "D",
    "D",
    "C",
    "C",
    "D",
    "D",
    "D",
    "E",
    "E",
    "D",
    "D",
    "E",
    "E",
    "E",
    "F",
    "F",
    "F",
    "G",
    "G",
    "F",
    "F",
    "G",
    "G",
    "G",
    "A",
    "A",
    "G",
    "G",
    "A",
    "A",
    "A",
    "B",
    "B",
    "A",
    "A",
    "B",
    "B",
    "B",
    "C"
  ],
  "note_colors": [
    "#ff9696",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#dee2da",
    "#bfaaa9",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#dee2da",
    "#bfaaa9",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#dee2da",
    "#bfaaa9",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#dee2da",
    "#bfaaa9",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#d3c6c5",
    "#d0d0d7",
    "#dee2da",
    "#bfaaa9",
    "#ffe5e5",
    "#ffffff",
    "#e5b9bb",
    "#ffe5e5"
  ],
  "equivSteps": 41,
  "fundamental": 440,
  "reference_degree": 31,
  "center_degree": 0,
  "rSteps": 17,
  "drSteps": 8,
  "hexSize": 42,
  "rotation": -20,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3
}
